import React from 'react';
import { motion } from 'framer-motion';
import { LayoutList, Clock, BrainCircuit } from 'lucide-react';
export function Benefits() {
  const pillars = [{
    icon: <LayoutList className="w-8 h-8 text-emerald-600" data-id="element-12" />,
    title: 'MÁS ORDEN EN CADA BÚSQUEDA',
    desc: 'Sabés qué preguntar, qué filtrar, qué registrar y qué validar en cada etapa del proceso.'
  }, {
    icon: <Clock className="w-8 h-8 text-emerald-600" data-id="element-13" />,
    title: 'MENOS TIEMPO PERDIDO',
    desc: 'Dejás de revisar perfiles sin criterio, entrevistar sin estructura o esperar feedback sin seguimiento.'
  }, {
    icon: <BrainCircuit className="w-8 h-8 text-emerald-600" data-id="element-14" />,
    title: 'MÁS CRITERIO PROFESIONAL',
    desc: 'Presentás candidatos con argumentos claros, fortalezas, dudas y recomendación concreta.'
  }];
  return <section className="py-24 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto px-6" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-18">
            UN SISTEMA PARA DEJAR DE TRABAJAR A CIEGAS
          </h2>
          <div className="inline-block px-4 py-1.5 bg-slate-100 rounded-full text-slate-700 font-semibold text-sm mb-6" data-id="element-19">
            KIT Recruiter PRO™
          </div>
          <h3 className="text-xl md:text-2xl font-medium text-slate-700 mb-6" data-id="element-20">
            Sistema práctico de selección en 7 etapas
          </h3>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-21">
            Creamos un sistema claro y aplicable para que dejes de manejar
            búsquedas como una suma de CVs, entrevistas y mensajes sueltos… y
            empieces a conducir cada proceso con orden, filtros y próximos pasos
            definidos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-22">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-23">
              <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-24">
                {pillar.icon}
              </div>
              <h4 className="text-xl font-display font-bold text-slate-900 mb-3" data-id="element-25">
                {pillar.title}
              </h4>
              <p className="text-slate-600 leading-relaxed" data-id="element-26">{pillar.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}